// extracted by css-extract-rspack-plugin
export default {"status":"status-OY1MHv","statusIcon":"statusIcon-n_yjY5"};